import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
  
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  
} from '@backstage/core-plugin-api';
import { GraphQLEndpoints, graphQlBrowseApiRef } from '@backstage-community/plugin-graphiql';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: graphQlBrowseApiRef,
    deps: { },
    factory: () =>
      GraphQLEndpoints.from([
        // use the create function to connect an unauthenticated GraphQL API
        GraphQLEndpoints.create({
          id: 'gitlab',
          title: 'GitLab',
          url: 'https://gitlab.com/api/graphql',
          headers: { 'Some-Key': 'Some-Value' }
        }),
        GraphQLEndpoints.create({
          id: 'aswering-api',
          title: 'answering-api',
          url: 'https://answering-api-qa-au.hasura.app/v1/graphql',
          headers: { 'x-hasura-admin-secret': 'bsEmqjjUFJPa8hVqGr4Ssy4SqQ2rdhK92NjBfaZq0aCdJi3UILYgTyHNmIo2mjQi' }
        })
      ])
  })
];
